<app-muv-ride-list *ngIf="!showMuvRideForm && !viewingRide" (addTrip)="showForm()" [patientTripId]="patientTrip.id" [rides]="rides" (viewRide)="viewRide($event)"></app-muv-ride-list>

<app-muv-ride-form *ngIf="showMuvRideForm" (showList)="hideForm()" [patientTrip]="patientTrip"></app-muv-ride-form>

<app-muv-ride-view #viewRideDetail (backToList)="onBackToList()" [class.visibility-hidden]="!viewingRide"></app-muv-ride-view>
